import type { FollowUpRequestsQueryVariables } from '@/gql/graphql';
import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchFollowUpRequests = async (variables: FollowUpRequestsQueryVariables = {}) => {
  const response = await queryExecute({
    variables,
    fetchPolicy: 'no-cache',
    query: graphql(`
      query FollowUpRequests($pagination: PaginationInputType, $dueWithinMinutes: Int) {
        followUpRequests(pagination: $pagination, dueWithinMinutes: $dueWithinMinutes) {
          count
          rows {
            id
            status
            phoneNumber
            firstName
            lastName
            followUpAt
            serviceType
            callLogId
            callerId
            leadId
            followUpCallLogId
            calledAt
            notes
            smsSentAt
            createdAt
          }
        }
      }
    `),
  });

  return response.data?.followUpRequests;
};
